import { create } from 'zustand';
import { ApiUtils, type MessageEntity, MessagesApi } from '@shared/api';

interface UseSendMessageStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  sendMessage: (message: MessageEntity, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSendMessageStore = create<UseSendMessageStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  sendMessage: async (message, signal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.sendMessage(message, signal);
      set({ loading: false, data: true });
    } catch (error) {
      set({ loading: false, data: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
